import React, { useEffect, useState } from 'react'
import './ModalFormResponse.scss'
import BlurOverlay from "../BlurOverlay";

function ModalFormResponse(data) {
  const [modalSuccessOpen, setModalSuccessOpen] = useState(false)

  const closeModal = () => {
    document.body.classList.remove('disable-scroll', 'overflow-hidden')
    setModalSuccessOpen(false)
  }

  useEffect(() => {
    setModalSuccessOpen(data.status)
    const header = document.getElementById('js-header')
    header.classList.add('blur-overlay-on')
  }, [])

  if (!modalSuccessOpen) {
    return null
  }

  return (
    <>
      {modalSuccessOpen ? <BlurOverlay isOverlayOpen={modalSuccessOpen} section={'modal'}></BlurOverlay> : ''}
      <div className='success-holder'>
        <div className='success-wrapper'>
          <a href='#' onClick={closeModal} className="modal-close">
            <span className="top"></span>
            <span className="bottom"></span>
          </a>
          <div className='success-title'>{data.title}</div>
          <div className='success-content'>{data.message}</div>
        </div>
      </div>
    </>
  )
}

export default ModalFormResponse
